<template>
  <div>
    <div class="p-3 card mb-3">
      <label class="titlePage">Configuração Definida das Datas e Grupos de Aplicação</label>

      <fccTable
        striped
        hover
        responsive
        search
        pagination
        :disabled="disabled"
        :fields="fields"
        :items="lista"
        :porPage="itemsPorPage"
        @row-selected="selecionaLinha"
      >
      </fccTable>

      <div class="text-right mb-3">
        <fccButton
          @click="excluir"
          class="mr-2"
          :disabled="dadosSelecionados.length <= 0 || abaDesabilitada"
          >{{ labelsSystem.excluir }}</fccButton
        >
        <fccButton @click="finalizar" v-if="mostraFinalizar">Finalizar</fccButton>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../../../store'
import { TP_ETAPA, TP_SITUACAO } from '../../constantes.js'

export default {
  props: ['lista', 'abaDesabilitada'],
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    },
    status() {
      return fccStore.state.localDeProva.listaStatus
    },
    mostraFinalizar() {
      return !this.status?.find((item) => item.tpEtapa === TP_ETAPA.CONFIGURACAO)?.tpSituacao
    },
    disabled() {
      const status = this.status?.find((item) => item.tpEtapa === TP_ETAPA.CONFIGURACAO)
      return (
        status?.tpSituacao === TP_SITUACAO.FINALIZADO ||
        status?.tpSituacao === TP_SITUACAO.CANCELADO
      )
    }
  },
  data() {
    return {
      itemsPorPage: 10,
      dadosSelecionados: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'fase', label: 'Fase', sortable: true },
        { key: 'aplicacao', label: 'Aplicação', sortable: true },
        { key: 'dataaplicacao', label: 'Data de Aplicação', sortable: true },
        { key: 'grupo', label: 'Grupo', sortable: true },
        { key: 'provas', label: 'Provas', sortable: true },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataconfiguracao', label: 'Data Configuração', sortable: true }
      ]
    }
  },
  methods: {
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    finalizar() {
      const payload = {
        idLocalConfig: this.configuracao.idlocalconfig,
        tpEtapa: TP_ETAPA.CONFIGURACAO,
        tpSituacao: TP_SITUACAO.FINALIZADO,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      this.callConfirm('Deseja finalizar a configuração?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .post(
              fccStore.state.baseUrlLocalDeProva + 'LocalExameConfig/FinalizarLocalExameConfig',
              payload,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              fccStore.dispatch(
                'localDeProva/fetchListaStatus',
                this.dadosLoginSession.fccTokenHeaders
              )
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto())
        }
      })
    },
    excluir() {
      const data = this.dadosSelecionados.map((item) => {
        return {
          idDataGrupo: item.iddatagrupo,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      const { headers } = this.dadosLoginSession.fccTokenHeaders

      axios
        .delete(fccStore.state.baseUrlLocalDeProva + `DataGrupo/Delete`, {
          headers,
          data
        })
        .then(() => {
          this.$emit('atualizar-lista')
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>